import React from "react";
import { Header } from "@/widgets/header";
import { Footer } from "@/widgets/footer";
import { HeroSection, Section1, Section2, Section3 } from "@/features/home";

/**
 * HomePage - Main landing page
 *
 * Structure:
 * - Header (GNB)
 * - Hero Section (Main banner + CTA)
 * - Section 1 (AI Learning Friend)
 * - Section 3 (Parent Reviews)
 * - Section 4 (Digital Hybrid Learning Features)
 * - Footer
 */
export const HomePage: React.FC = () => {
  return (
    <div className="w-full flex flex-col bg-white">
      {/* Main Content */}
      <main className="flex-1">
        {/* Hero Section */}
        <HeroSection />

        {/* Section 1 - AI Learning Friend */}
        <Section1 />

        {/* Section 2 - Digital Hybrid Learning Class */}
        <Section2 />

        {/* Section 3 - Parent Reviews */}
        <Section3 />
      </main>
    </div>
  );
};
